import { render, staticRenderFns } from "./PermissionPage.vue?vue&type=template&id=4c052a0c&scoped=true&"
import script from "./PermissionPage.vue?vue&type=script&lang=js&"
export * from "./PermissionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c052a0c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c052a0c')) {
      api.createRecord('4c052a0c', component.options)
    } else {
      api.reload('4c052a0c', component.options)
    }
    module.hot.accept("./PermissionPage.vue?vue&type=template&id=4c052a0c&scoped=true&", function () {
      api.rerender('4c052a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/PermissionPage.vue"
export default component.exports